var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"admin-layout",class:{ 'observability-admin-layout': _vm.$route.name === 'ApiObservability' }},[_c('admin-sidebar'),_c('div',{staticClass:"admin-layout-body py-3 px-2"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }